export const formatPercentage = (value: number) => {
  if (value % 1 === 0) {
    return `${value}%`;
  }
  return `${value.toFixed(2)}%`;
};
